import {
  RouteView,
  PageView
} from '@/layouts'
import {
  bxAnaalyse
} from '@/core/icons'

export const financeRouter = [{
  path: '/finance',
  redirect: '/finance/accountMoney',
  component: RouteView,
  name: 'financeGroup',
  meta: {
    title: '财务',
    keepAlive: true,
    icon: 'transaction'
  },
  children: [
    {
      path: '/finance/accountMoney',
      redirect: '/finance/accountMoney/accountDetails',
      component: RouteView,
      name: 'AccountMoneyGroup',
      meta: {
        title: '账户资金',
        keepAlive: true
      },
      children: [{
        path: '/finance/accountMoney/accountDetails',
        name: 'AccountDetails',
        component: () => import('@/views/finance/accountMoney/AccountDetails'),
        meta: {
          title: '账户概览',
          keepAlive: true
        }
      },
        {
          hidden: true, //不显示在菜单上
          path: '/finance/accountMoney/accountSetting',
          name: 'AccountSetting',
          component: () => import('@/views/finance/accountMoney/AccountSetting'),
          meta: {
            title: '收款账户设置',
            keepAlive: false,
            hideInMenu: true
          }
        },
        {
          path: '/finance/accountMoney/balanceRecharge',
          name: 'BalanceRecharge',
          component: () => import('@/views/finance/accountMoney/BalanceRecharge'),
          meta: {
            title: '余额充值',
            keepAlive: false
          }
        },
        {
          path: '/finance/accountMoney/extractMoney',
          name: 'ExtractMoney',
          component: () => import('@/views/finance/accountMoney/ExtractMoney'),
          meta: {
            title: '资金提现',
            keepAlive: false
          }
        },
        {
          path: '/finance/accountMoney/creditPayment',
          name: 'CreditPayment',
          component: () => import('@/views/finance/accountMoney/CreditPayment'),
          meta: {
            title: '授信还款',
            keepAlive: false
          }
        },
        {
          path: '/finance/accountMoney/withdraw',
          name: 'WithdrawList',
          component: () => import('@/views/finance/accountMoney/WithdrawList'),
          meta: {
            title: '分销提现',
            keepAlive: false
          }
        }
        // {
        //   path: '/finance/accountMoney/transferAudit',
        //   name: 'TransferAudit',
        //   component: () => import('@/views/finance/accountMoney/TransferAudit'),
        //   meta: {
        //     title: '转账审核',
        //     keepAlive: false
        //   },
        // },
      ]
    },
    {
      path: '/finance/transactionCheck',
      redirect: '/finance/transactionCheck/incomeExpend',
      component: RouteView,
      name: 'TransactionCheckGroup',
      meta: {
        title: '交易对账',
        keepAlive: true
      },
      children: [{
        path: '/finance/transactionCheck/incomeExpend',
        name: 'IncomeExpend',
        component: () => import('@/views/finance/transactionCheck/IncomeExpend'),
        meta: {
          title: '收支明细',
          keepAlive: true
        }
      },
        {
          path: '/finance/transactionCheck/accountCheck',
          name: 'AccountCheck',
          component: () => import('@/views/finance/transactionCheck/AccountCheck'),
          meta: {
            title: '对账单',
            keepAlive: true
          }
        },
        {
          path: '/finance/balance/reconciliation/mc',
          name: 'BalanceReconciliation',
          component: () => import('@/views/finance/balanceReconciliation/index.vue'),
          meta: {
            title: '余额对账',
            keepAlive: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/finance/transactionCheck/checkUnitDetails',
          name: 'CheckUnitDetails',
          component: () => import('@/views/finance/transactionCheck/CheckUnitDetails'),
          meta: {
            title: '账单详情',
            keepAlive: false,
            hideInMenu: true
          }
        }
      ]
    },
    {
      path: '/finance/invoice',
      redirect: '/finance/invoice/AuditInvoice',
      component: RouteView,
      meta: {
        title: '发票管理',
        keepAlive: true
      },
      name:"InvoiceGroup",
      children: [{
        path: '/finance/invoice/auditInvoice',
        name: 'AuditInvoice',
        component: () => import('@/views/finance/invoice/AuditInvoice'),
        meta: {
          title: '发票审核',
          keepAlive: true
        }
      },
        {
          hidden: true, //不显示在菜单上
          path: '/finance/transactionCheck/invoiceDetails',
          name: 'InvoiceDetails',
          component: () => import('@/views/finance/invoice/InvoiceDetails'),
          meta: {
            title: '发票详情',
            keepAlive: false,
            hideInMenu: true
          }
        },
        {
          path: '/finance/invoice/ApplyInvoice',
          name: 'ApplyInvoice',
          component: () => import('@/views/finance/invoice/ApplyInvoice'),
          meta: {
            title: '申请发票',
            keepAlive: true
          }
        },
        {
          hidden: true, //不显示在菜单上
          path: '/finance/transactionCheck/historicalDetails',
          name: 'HistoricalDetails',
          component: () => import('@/views/finance/invoice/HistoricalDetails'),
          meta: {
            title: '申请发票历史详情',
            keepAlive: false,
            hideInMenu: true
          }
        }
      ]
    },

    {
      path: '/finance/financialData',
      redirect: '/finance/financialData/RechargeRecord',
      component: RouteView,
      name: 'financialDataGroup',
      meta: {
        title: '财务数据',
        keepAlive: true
      },
      children: [
        {
          path: '/finance/financialData/RechargeRecord',
          name: 'RechargeRecord',
          component: () => import('@/views/finance/financialData/RechargeRecord'),
          meta: {
            title: '充值记录',
            keepAlive: false
          }
        },
        {
          path: '/finance/financialData/WithdrawalRecord',
          name: 'WithdrawalRecord',
          component: () => import('@/views/finance/financialData/WithdrawalRecord'),
          meta: {
            title: '提现记录',
            keepAlive: false
          }
        }
        // {
        //   hidden: true,  //不显示在菜单上
        //   path: '/finance/components/NewWithdrawalRequest',
        //   name: 'NewWithdrawalRequest',
        //   component: () => import('@/views/finance/components/NewWithdrawalRequest'),
        //   meta: {
        //     title: '新建提现',
        //     keepAlive: false
        //   }
        // }
      ]
    }
  ]
}]